<div *ngIf="hasPresenterRole()">
	<span class="not-submitted" *ngIf="activity.have_i_submitted === false" translate="common_unsubmitted"></span>
	<span class="has-submitted" *ngIf="activity.have_i_submitted">
		<span *ngIf="isNotGraded()" class="not-graded submitted" translate="common_submitted"></span>
		<span *ngIf="hasNoScores()" class="is-unscored" translate="common_unscored">
		</span>
		<span *ngIf="hasScores()" class="is-scored">
			{{ activity.my_score + " / " + activity.total_score }}
		</span>
	</span>
</div>
<div *ngIf="hasReviewerOrHigherRole()">
	<span
		*ngIf="isNotGraded() && activity.usage >= 0"
		class="not-graded"
		translate="activity-list-num-submitted"
		[translateParams]="{ number: activity.usage }">
	</span>
	<span
		*ngIf="hasSomeGraded()"
		class="some-scored"
		translate="activity-list-status_some-scored"
		[translateParams]="{ score: activity.num_graded + ' / ' + activity.usage }"
	>
	</span>
	<span *ngIf="isAllGraded()">
		<span class="all-scored" translate="activity-list-status_all-scored"></span>
	</span>
</div>
